import { render, staticRenderFns } from "./CameraPageShootFace.vue?vue&type=template&id=4c4e54d3&scoped=true&"
import script from "./CameraPageShootFace.vue?vue&type=script&lang=ts&"
export * from "./CameraPageShootFace.vue?vue&type=script&lang=ts&"
import style0 from "./CameraPageShootFace.vue?vue&type=style&index=0&id=4c4e54d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4e54d3",
  null
  
)

export default component.exports